import service from '@/middleware'

const sectorApi = {
    /**
     * Para eliminar un sector
     * @param {*} id
     */
    async canDeleteSector (id) {
        const result = await service.http.get(`/api/sector/can-delete/${id}`)
        return result
    },

    /**
     * Obtener todos los sectores de una empresa
     */
    async getAllByEnterpriseId (enterpriseId) {
        const result = await service.http.get(`/api/sector/enterprise/${enterpriseId}`)
        return result
    },

    /**
     * Obtener todos los sectores de una empresa y un tipo de equipo
     */
    async getAllByEnterpriseIdAndTypeId (enterpriseId, typeId) {
        const result = await service.http.get(`/api/sector/enterprise/${enterpriseId}/type/${typeId}`)
        return result
    }
}

export default sectorApi